/* eslint-disable jsx-a11y/accessible-emoji */

import React from "react";

export default function CommunityGreenery() {
  return (
    <div>
      <iframe
        style={{
          width: "100vw",
          height: "100vh",
          border: "none",
        }}
        src="https://storymaps.arcgis.com/stories/93df366589b24ccb97bb713a01aee92f"
      />
    </div>
  );
}
